import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import MainPage from "./pages/MainPage";
import AboutPage from "./pages/AboutPage";
import StationsMapPage from "./pages/StationsMapPage";
import ClientsPage from "./pages/ClientsPage";
import GovernmentProcurementsPage from "./pages/GovernmentProcurementsPage";

import NewsPage from "./pages/subpages/NewsPage";
import DetailsPage from "./pages/subpages/DetailsPage";
import SocialActivitiesPage from "./pages/subpages/SocialActivitiesPage";
import VacanciesPage from "./pages/subpages/VacanciesPage";
import UsefulInfoPage from "./pages/subpages/UsefulInfoPage";
import ContactsPage from "./pages/subpages/ContactsPage";
import MiniMarketsPage from "./pages/subpages/MiniMarketsPage";
import ErrorPage from "./pages/ErrorPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<MainPage />} />

          <Route path="/about_company" element={<AboutPage />} />
          <Route path="/about_company/news" element={<NewsPage />} />
          <Route path="/about_company/news/details/:id" element={<DetailsPage />} />
          <Route path="/about_company/social_activities" element={<SocialActivitiesPage />} />
          <Route path="/about_company/vacancies" element={<VacanciesPage />} />
          <Route path="/about_company/contacts" element={<ContactsPage />} />
          <Route path="/rus/about/mobile-politics" element={<PrivacyPolicyPage language="ru" />} />
          <Route path="/kg/about/mobile-politics" element={<PrivacyPolicyPage language="kg" />} />

          <Route path="/stations" element={<StationsMapPage />} />
          <Route path="/stations/mini_markets" element={<MiniMarketsPage />} />
          <Route path="/for_clients" element={<ClientsPage />} />
          <Route path="/for_clients/usefull_info" element={<UsefulInfoPage />} />
          <Route path="/government_procurements" element={<GovernmentProcurementsPage />} />

          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
